import DOMPurify from 'dompurify';

const ensureSpaceAroundTags = (html: string): string =>
  html
    .replace(/(\w)(<strong>)/g, '$1 $2')
    .replace(/(<\/strong>)(\w)/g, '$1 $2');

// Strip all raw HTML-like fragments first, then only re-introduce bold
// via well-formed <mark>...</mark> pairs or **...** markdown.
// This prevents garbled agent output like "<96mark>96" from corrupting display.
export function sanitizeAgentText(text: string): string {
  // Step 1: Extract well-formed <mark>...</mark> pairs before stripping HTML.
  // Replace them with a placeholder to preserve through the strip step.
  const markPairs: string[] = [];
  let processed = text.replace(
    /<mark>([\s\S]*?)<\/mark>/gi,
    (_, content) => {
      markPairs.push(content);
      return `\x00MARK${markPairs.length - 1}\x00`;
    },
  );

  // Step 2: Strip ALL remaining HTML-like tags (malformed marks, stray tags, etc.)
  processed = processed.replace(/<\/?[^>]*>/g, '');

  // Step 3: Restore the well-formed mark pairs as <strong>
  processed = processed.replace(
    /\x00MARK(\d+)\x00/g,
    (_, idx) => `<strong>${markPairs[Number(idx)]}</strong>`,
  );

  // Step 4: Convert markdown bold **...**
  processed = processed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // Step 5: Sanitize with DOMPurify
  const sanitized = DOMPurify.sanitize(processed, {
    ALLOWED_TAGS: ['strong', 'em', 'b', 'i', 'br'],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
  });

  return ensureSpaceAroundTags(sanitized);
}
